import { useContext, useEffect } from 'react'
import { GuestsDataContext } from './guestsDataProvider'

interface UseGuestsFormProps {
    voucherProductId?: string
    voucherPrice?: number
}

const useGuestsForm = ({
    voucherProductId,
    voucherPrice,
}: UseGuestsFormProps) => {
    const { marchVouchersData, setMarchVouchersData, setTotalPrice } =
        useContext(GuestsDataContext)

    // TODO: rewrite with better solution + react-forms
    const setFieldInputValue = (value: string, name: string, index: number) => {
        setMarchVouchersData(
            marchVouchersData.map((data, dataIndex) => {
                if (dataIndex === index - 1)
                    return {
                        ...marchVouchersData[index - 1],
                        ...(name === 'firstName'
                            ? { firstName: value }
                            : { lastName: value }),
                    }
                return data
            })
        )
    }

    // on init - optionally set price and productId for selected option of promotional voucher
    useEffect(() => {
        if (
            voucherPrice === undefined ||
            !voucherProductId ||
            marchVouchersData.length === 0
        )
            return

        // skip if selected option for voucher is already applied
        if (marchVouchersData[0].price === voucherPrice) return

        const totalPrice =
            marchVouchersData
                .map(({ tickets }) => tickets.length)
                .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                ) * voucherPrice

        setTotalPrice(totalPrice)

        setMarchVouchersData(
            marchVouchersData.map((data) => ({
                ...data,
                price: voucherPrice,
                productId: voucherProductId,
            }))
        )
    }, [voucherPrice, voucherProductId, marchVouchersData])

    return {
        marchVouchersData,
        setFieldInputValue,
        areVouchersDataReady: !!marchVouchersData.length,
    }
}

export default useGuestsForm
